import { MutationOptions, useQueryClient } from '@tanstack/react-query';
import { useApiMutation } from '~/hooks';
import {
  updateProfileApi,
  UpdateProfileData,
  UserProfile,
} from '../repository';
import { PROFILE_QUERY_KEYS } from '../queries/user';

/**
 * Mutation hook for updating user profile
 * @param options - Additional mutation options
 * @returns React Query mutation result
 */
export const useUpdateProfileMutation = (
  options?: MutationOptions<UserProfile, CustomAxiosError, UpdateProfileData>,
) => {
  const queryClient = useQueryClient();

  return useApiMutation({
    ...options,
    mutationFn: (data: UpdateProfileData) => updateProfileApi(data),
    onSuccess: async (...rest) => {
      // Invalidate profile query to refetch updated data
      await queryClient.invalidateQueries({
        queryKey: [PROFILE_QUERY_KEYS.PROFILE],
      });

      // Call any additional onSuccess handlers
      options?.onSuccess?.(...rest);
    },
  });
};
